import { z } from "zod"

export const draftSchema = z.object({})

export const finalSchema = z.object({
    serviceDate:   z.string().min(1, "La fecha de servicio es obligatoria"),
    serviceTypes:  z.array(z.string()).min(1, "El tipo de servicio es obligatorio"),
    serviceReason: z.string().min(1, "El motivo del servicio es obligatorio"),
    finalStatus:   z.string().min(1, "El estado final del equipo es obligatorio"),
    clientEmail:   z.string().email("Ingresa un correo válido").or(z.literal("")).optional(),
})

export type FinalSchemaErrors = Partial<Record<keyof z.infer<typeof finalSchema>, string>>
